import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";

const AdminLoginPage = () => {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (loading) return <div className="pt-40 text-center">…</div>;
  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Benvenuto!");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login fallito";
      toast.error(typeof msg === "string" ? msg : "Errore");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-screen pt-40 pb-20 px-6">
      <div className="max-w-md mx-auto">
        <p className="overline text-[color:var(--wine)] flex items-center">
          <span className="section-line"></span>
          Area riservata
        </p>
        <h1 className="mt-6 font-serif-display text-5xl lg:text-6xl leading-[0.95] tracking-tight">
          Accedi al pannello.
        </h1>
        <p className="mt-6 text-[color:var(--ink-2)]">
          Solo personale Caffè & Cucina Sorriso.
        </p>

        <form onSubmit={submit} className="mt-12 space-y-6" data-testid="admin-login-form">
          <div>
            <Label htmlFor="al-email" className="overline text-[color:var(--ink-3)]">Email</Label>
            <Input
              id="al-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-email-input"
              required
              className="mt-2 rounded-none border-0 border-b border-[color:var(--line)] bg-transparent focus-visible:ring-0 focus-visible:border-[color:var(--wine)] px-0 text-lg"
            />
          </div>
          <div>
            <Label htmlFor="al-pwd" className="overline text-[color:var(--ink-3)]">Password</Label>
            <Input
              id="al-pwd"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-password-input"
              required
              className="mt-2 rounded-none border-0 border-b border-[color:var(--line)] bg-transparent focus-visible:ring-0 focus-visible:border-[color:var(--wine)] px-0 text-lg"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="btn-primary w-full disabled:opacity-50"
          >
            {submitting ? "Accesso..." : "Entra"}
            <Lock size={14} strokeWidth={1.5} />
          </button>
        </form>
      </div>
    </main>
  );
};

export default AdminLoginPage;
